module.exports = __webpack_public_path__ + "img/house-in-allotment-3.dd1e3210.jpg";